import React from "react";
import PropTypes from "prop-types";
const SVG_TITLE_ID = 'footer-heart';
const Heart = _ref => {
  let {
    className
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    "aria-labelledby": SVG_TITLE_ID,
    className: className,
    height: "14",
    role: "img",
    width: "19",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", {
    id: SVG_TITLE_ID
  }, "love"), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.5 3.5c.5-1 1.4-3.5 4.3-3.5 2.8 0 5.4 1.9 5.2 5.9-.2 2.6-3.3 5.3-9.5 8C3.3 11.3.2 8.6 0 6-.2 1.9 2.4 0 5.2 0 8.1 0 9 2.5 9.5 3.5z"
  }));
};
process.env.NODE_ENV !== "production" ? Heart.propTypes = {
  className: PropTypes.string
} : void 0;
export default Heart;